import { useState } from "react";
import { withTranslation } from "react-i18next";
import {
  Menu,
  IconButton,
  Tooltip,
} from '@mui/material/';
import PDFMenuItem from "./DownloadReportPDF";
import CSVMenuItem from "./DownloadReportCSV";
import DownloadIcon from "@mui/icons-material/Download";

const ReportMenu = withTranslation()(({ t, data, deviceData, rebootTime, dateNow, range, charts, referece, headers, fileName, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleOpenClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t("download-report")}>
        <IconButton
          sx={{ m: 0 }}
          onClick={handleOpenClick}
          disabled={disabled}
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
      >
        <PDFMenuItem 
          deviceData={deviceData}
          rebootTime={rebootTime}
          dateNow={dateNow}
          range={range}
          charts={charts}
          referece={referece}
          closeFn={handleClose}
        />
        <CSVMenuItem 
          data={data}
          headers={headers}
          fileName={fileName}
          closeFn={handleClose}
        />
      </Menu>
    </>
  );
});
export default ReportMenu;